import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

export const getExtensionUnits = async () => {
    const { data } = await axios.get(API_ROUTES.EXTENSION_UNITS);
    return data;
};